/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Work_Order_Publish_Option_PassInputs */



/**
* | output |
* | --- |
* | "Pass" |
*
* @param {Work_Order_Publish_Option_PassInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const work_order_publish_option_pass = /** @type {((inputs?: Work_Order_Publish_Option_PassInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_Order_Publish_Option_PassInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Approuvé")
	if (locale === "de") return /** @type {LocalizedString} */ ("Passieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Passaggio")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Проходить")
	if (locale === "es") return /** @type {LocalizedString} */ ("Aprobar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("经过")
	if (locale === "ja") return /** @type {LocalizedString} */ ("合格")
	if (locale === "hi") return /** @type {LocalizedString} */ ("उत्तीर्ण")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Passar")
	return /** @type {LocalizedString} */ ("Pass")
});